import api, { TipoOptions } from '../api';
import { trackPromise } from 'react-promise-tracker';
import Axios from 'axios';
import { getJwt } from '@app/helpers';

import {
  CrfCicloOrcamentarioRelatorio,
  CrfRelatorioCapexManeger,
  ICrfRelatorioCicloOrcamentario,
  CrfCicloOrcamentarioProjetoPacote,
  CrfCicloOrcamentarioProjetoDadosGerais
} from './crfRelatorioCicloOrcamentario';
import { CrfTabelaProjetoOverViewResult } from './crftabelaProjetoOverView';
import { ICrfRegistroEsin204 } from './crfesin204';
import { clickDownloadElement } from '@app/helpers/download';
import { CrfProjeto, CrfRequisitadoRc } from './crfProjeto';
import { CrfRegistroEsin204Importacao } from './CrtRegistroEsin204';

const controller = "fechamentoCrFch"

export interface ICrfFechamentoResult {
  versao: number;
  ano: number;
  mes: number;
  createdAtFormatado: string;
  index: number;
  status: string;
}

export interface ICrfFechamentoRegistroEsin204 {
  id: string;
  ano: number;
  resultAno: ICrfRegistroEsin204[];
  carregarMesAno: boolean;
  meses: string[];
}

export interface ICrfTotalProjeto {
  totalProjeto: number;
  numeroProjetoAtual: number;
  descricaoEtapa: string;
  codigoProjetoAtual: string;
}

export interface CrfProcessoRotinas {
  solicitarGeracaoDoRelatorioFechamento: boolean;
  fechamentoEmProcessamento: boolean;
}

export const solicitarGeracaoDoRelatorioCrfFechamento = () =>
  api.post(`${controller}/solicitarGeracaoDoRelatorioCrfFechamento`);

export const getCrfFechamentoAtual = () =>
  api.get<string>(`fechamento/getFechamentoAtual`);

export const getAllCrfFechamento = () =>
  api.get<ICrfFechamentoResult[]>(controller);

export const getCrfFechamentoExecutiveSummary = (fechamentoId: string) =>
  api.get<CrfRelatorioCapexManeger>(`${controller}/${fechamentoId}/executiveSummary`);

export const getCrfFechamentoCurvaEconomica = (fechamentoId: string) =>
  api.get<ICrfRelatorioCicloOrcamentario>(`${controller}/${fechamentoId}/curvaEconomica`);

export const getCrfFechamentoReportPerformaceProject = (fechamentoId: string) =>
  api.get<CrfTabelaProjetoOverViewResult[]>(`${controller}/${fechamentoId}/ReportPerformaceProject`);

export const getCrfFechamentoCicloAnoByFechamentoId = (fechamentoId: string) =>
  api.get<CrfCicloOrcamentarioRelatorio>(`${controller}/${fechamentoId}/cicloAno`);

export const getCrfFechamentoControleRfaByFechamentoId = (fechamentoId: string) =>
  api.get<CrfCicloOrcamentarioRelatorio>(`${controller}/${fechamentoId}/rfa`);

export const getCrfFechamentoModuloExecutadoByFechamentoId = (fechamentoId: string) =>
  api.get<ICrfFechamentoRegistroEsin204[]>(`${controller}/${fechamentoId}/moduloExecutado`);

export const getCrfFechamentExecutadoMesAnoByFechamentoId = (fechamentoId: string, mes: string, ano: number) =>
  api.get<CrfRegistroEsin204Importacao[]>(`${controller}/${fechamentoId}/moduloExecutadoMesAno?mes=${mes}&ano=${ano}`);

export const getCrfFechamentoPluriAnualByFechamentoId = (fechamentoId: string) =>
  api.get<CrfCicloOrcamentarioRelatorio>(`${controller}/${fechamentoId}/pluriAnual`);


export const exportarCrfFechamentoPluriAnual = (fechamentoId: any, nomeDoArquivo: string) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/${controller}/${fechamentoId}/exportar/pluriAnual`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      clickDownloadElement(
        [resp.data],
        nomeDoArquivo,
        'downloadElementExportarFechamentoPluriAnual'
      );
    }),
  );
};

export const exportarCrfFechamentoCicloOrcamentario = (fechamentoId: any, nomeDoArquivo: string) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/${controller}/${fechamentoId}/exportar/cicloOrcamentario`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      clickDownloadElement(
        [resp.data],
        nomeDoArquivo,
        'downloadElementExportarFechamentoCicloOrcamentario'
      );
    }),
  );
};

export const exportarCrfFechamentoCicloOrcamentarioProjetoPacote = (fechamentoId: any, nomeDoArquivo: string) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/${controller}/${fechamentoId}/exportar/cicloOrcamentarioProjetoPacote`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      clickDownloadElement(
        [resp.data],
        nomeDoArquivo,
        'downloadElementExportarFechamentoCicloOrcamentarioProjetoPacote'
      );
    }),
  );
};

export const getFechamentoCicloAnoGraficoCurvaProjeto = (fechamentoId: string, projetoId: string) =>
  api.get<ICrfRelatorioCicloOrcamentario>(`${controller}/getFechamentoCicloAnoGraficoCurvaProjeto/${fechamentoId}/${projetoId}`);
export const getFechamentoCicloAnoPacoteProjeto = (fechamentoId: string, projetoId: string) =>
  api.get<CrfCicloOrcamentarioProjetoPacote>(`${controller}/getFechamentoCicloAnoPacoteProjeto/${fechamentoId}/${projetoId}`);
export const getFechamentoCicloOrcamentarioDadosGeraisProjetoDetalhe = (fechamentoId: string, projetoId: string) =>
  api.get<CrfCicloOrcamentarioProjetoDadosGerais>(
    `${controller}/getFechamentoCicloOrcamentarioDadosGeraisProjetoDetalhe/${fechamentoId}/${projetoId}`,
  );
export const getFechamentoPluriAnualGraficoCurvaProjeto = (fechamentoId: string, projetoId: string) =>
  api.get<ICrfRelatorioCicloOrcamentario>(
    `${controller}/getFechamentoPluriAnualGraficoCurvaProjeto/${fechamentoId}/${projetoId}`,
  );
export const getFechamentoPluriAnualPacoteProjeto = (fechamentoId: string, projetoId: string) =>
  api.get<CrfCicloOrcamentarioProjetoPacote>(
    `${controller}/getFechamentoPluriAnualPacoteProjeto/${fechamentoId}/${projetoId}`,
  );
export const getFechamentoProjetoRequisitado = (fechamentoId: string, projetoId: string) =>
  api.get<CrfRequisitadoRc[]>(`${controller}/getFechamentoProjetoRequisitado/${fechamentoId}/${projetoId}`);

export const getFechamentoReportPerformaceProjectDetalhe = (fechamentoId: string, projetoId: string) => {
  return api.get<CrfProjeto>(`${controller}/getFechamentoReportPerformaceProjectDetalhe/${fechamentoId}/${projetoId}`);
}

export const exportarFechamentoProjetoCicloAnoPacote = (fechamentoId: any, projetoId: any, nomeDoArquivo: string) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/${controller}/exportarFechamentoProjetoCicloAnoPacote/${fechamentoId}/${projetoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadExportarFechamentoProjetoCicloAnoPacote');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadExportarFechamentoProjetoCicloAnoPacote').outerHTML = '';
    }),
  );
};

export const exportarFechamentoProjetoPluriAnual = (fechamentoId: any, projetoId: any, nomeDoArquivo: string) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/${controller}/exportarFechamentoProjetoPluriAnualPacote/${fechamentoId}/${projetoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadExportarFechamentoProjetoPluriAnual');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadExportarFechamentoProjetoPluriAnual').outerHTML = '';
    }),
  );
};

export const exportarFechamentoProjetoPluriAnualDetalhado = (
  fechamentoId: any,
  projetoId: any,
  nomeDoArquivo: string,
) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/${controller}/exportarFechamentoProjetoPluriAnualDetalhado/${fechamentoId}/${projetoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadExportarFechamentoProjetoPluriAnualDetalhado');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadExportarFechamentoProjetoPluriAnualDetalhado').outerHTML = '';
    }),
  );
};

export const exportarRelatorioProjetoOverFechamento = (fechamentoId: any, nomeDoArquivo: string,) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/${controller}/exportarRelatorioProjetoOverFechamento/${fechamentoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadExportarRelatorioProjetoOverFechamento');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadExportarRelatorioProjetoOverFechamento').outerHTML = '';
    }),
  );
};